import React, { useEffect, useState } from 'react';

export default function TimeLabel (props) {
  return (
    <>
      {(props.text && <span className='mb_label_time'><i className='hide'>영상길이</i>{props.text}</span>)}
    </>
  );
}
